import ajax from "../utils/request";

const sysMsgApi = {
  /********************************金刚区配置列表*********************************** */
  // 获取金刚区列表
  getSysMsgList(params) {
    return ajax({
      url: "/sysmsg/list",
      type: "get",
      params: params,
    });
  },
  addSysMsg(param) {
    return ajax({
      url: "/sysmsg/add",
      type: "post",
      params: param,
    });
  },
  editSysMsg(param) {
    return ajax({
      url: "/sysmsg/update",
      type: "post",
      params: param,
    });
  },
  removeSysMsg(param) {
    return ajax({
      url: "/sysmsg/del",
      type: "post",
      params: param,
    });
  },
};

export default sysMsgApi;
